import { Option } from 'effect';

import type { CartLine } from './order';

export type CartItemEventData = {
  readonly variantCode: string;
  readonly name: string;
  readonly unitPriceWithoutTax: number;
  readonly unitPriceBeforeDiscount: number;
};

/** A cart action keeps the values that its write and analytics event use. */
export type CartMutationItem = {
  readonly id: string;
  readonly quantity: number;
  readonly maxOrderable: number;
  readonly event: CartItemEventData;
};

export const toCartMutationItem = (line: CartLine): CartMutationItem => ({
  id: line.id,
  quantity: line.quantity,
  maxOrderable: Option.getOrElse(line.maxOrderable, () => Infinity),
  event: {
    variantCode: line.variantCode,
    name: Option.getOrElse(line.name, () => ''),
    unitPriceWithoutTax: Option.getOrElse(line.unitPriceWithoutTax, () => 0),
    unitPriceBeforeDiscount: Option.getOrElse(line.unitPriceBeforeDiscount, () => 0),
  },
});
